import React from 'react';
import { Route, Routes } from 'react-router-dom'
import './App.css'; 
import './Appointment/Appointments.css';
import AppLayout from "../Layouts/AppLayout";
import useUserAccess from "../Hooks/useUserAccess";
import AnonymousRoutes from "../Components/Routes/AnonymousRoutes";
import AuthenticatedRoutes from "../Components/Routes/AuthenticatedRoutes";

function App({ }) {
    const {isAuthenticated} = useUserAccess();

    return (
        <Routes>
            <Route element={<AppLayout/>}>
                {!isAuthenticated() ? <Route path="/*" element={<AnonymousRoutes/>}/> : <Route path="/*" element={<AuthenticatedRoutes/>}/>}
            </Route>
        </Routes>
    );
}

export default App;